<template>
  <div class="container">
    <!--第一屏-->
    <section
      v-if="banner.banner_img"
      class="banner banner-yoga relative"
      :style="{ backgroundImage: 'url(' + banner.banner_img + ')' }"
    >
      <div class="banner-text">
        <h1 class="title">{{ banner.title }}</h1>
        <p class="description small">{{ banner.subtitle }}</p>
      </div>
    </section>

    <!--第二屏幕-->
    <section class="section">
      <!-- <div class="content university">
        <ul class="university-nav clearfix">
          <li>
            <router-link
              :to="{ name: 'yogaUniversityRyt' }"
              :class="{ active: universityNav == 'RYT' }"
              >RYT教培</router-link
            >
          </li>
          <li>
            <router-link
              :to="{ name: 'yogaUniversityWorkshop' }"
              :class="{ active: universityNav == 'Workshop' }"
              >工作坊</router-link
            >
          </li>
          <li>
            <router-link
              :to="{ name: 'yogaUniversityLearnto' }"
              :class="{ active: universityNav == 'Learnto' }"
              >游学</router-link
            >
          </li>
          <li>
            <router-link
              :to="{ name: 'yogaUniversityTrain' }"
              :class="{ active: universityNav == 'Train' }"
              >训练营</router-link
            >
          </li>
          <li>
            <router-link
              :to="{ name: 'yogaUniversityCredential' }"
              :class="{ active: universityNav == 'Credential' }"
              >证书查询</router-link
            >
          </li>
        </ul>
      </div> -->

      <div class="content">
        <router-view></router-view>
      </div>
    </section>

    <!-- 报名信息 -->
    <!--     <section class="section university-taset" :class="{static:scrollBottom,hide:universityNav != 'RYT'}">
      <div class="content clearfix">
         <ul>
          <li><p>免费回拨咨询</p></li>
          <li><input v-model="name" type="text" name="" placeholder="请输入姓名" /></li>
          <li><input v-model="mobile" type="text" name="" placeholder="请输入手机号码" /></li>
          <li><p class="error">{{error}}</p></li>
          <li class="clearfix"><button class="pull-left" @click="apply()">提交</button> <a @click="buyRYT()"   class="blue pull-right" href="javascript:;">直接参加></a></li>
        </ul>

        <div v-show="isQrCode" class="mask-qrCode">
          <i class="cursor" @click="buyRYT()"></i>
          <div id="qrCodeRYT"></div>
        </div>
      </div>
    </section> -->
  </div>
</template>
<style lang="scss">
@import '../assets/style/variable';
.university-taset {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 320px;
  background: url('../assets/img/Mask.jpg') no-repeat center center;
  background-size: cover;
  padding: 20px 0;
  margin-bottom: 0 !important;
  z-index: 99;
  ul {
    margin: 0 auto;
  }
  p {
    font-size: $font-size-b2;
    color: $gray-darker;
    padding-bottom: 10px;
  }

  p.error {
    color: red;
    font-size: $font-size-small;
  }

  input {
    width: 250px;
    height: 30px;
    font-size: $font-size-base;
    text-indent: 10px;
    border: 1px solid $gray-lighters;
    margin-bottom: 10px;
  }

  button {
    font-size: $font-size-baser;
    width: 120px;
    height: 35px;
    margin-top: 10px;
    background: $blue;
    color: $white;
    border: none;
    border-radius: 5px;
  }

  a {
    margin-top: 20px;
  }

  .mask-qrCode {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #f9f9f9;
  }

  #qrCodeRYT img {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -60px;
    margin-left: -60px;
  }

  i {
    @include icon($width: 20px, $height: 20px, $url: '../assets/img/close.png');
    position: absolute;
    right: 5px;
    top: 5px;
  }
}

.university-taset.static {
  position: static;
}

@media (max-width: $screen-lm) {
  .university-taset {
    position: static;
    width: 100%;

    ul {
      float: static;
      margin: 0 auto;
    }
  }

  .university-nav {
    padding: 0%;

    li {
      width: 20%;
      margin: 0 !important;
      font-size: $font-size-small;
    }
    span {
      padding-bottom: 20px;
      height: 14px;
    }

    span.active::after {
      @include icon(
        $width: 14px,
        $height: 7px,
        $url: '../assets/img/Rectangle 4.png'
      );
      position: absolute;
      left: 50%;
      margin-left: -7px;
      bottom: 0;
    }
  }
}
</style>
<script>
import DY from '../assets/js/common';
import qs from 'qs';
import { reportPageViewEvent } from '../assets/js/saInstance';
import QRCode from '../../node_modules/qrcodejs2/qrcode';

var url = window.localStorage.user
  ? DY.payVip +
    '?session_id=' +
    this.id +
    '&payType=1&sid=' +
    JSON.parse(window.localStorage.user).sid
  : DY.o2Url + '?session_id=' + this.id + '&payType=1';

function changNavFun(name) {
  if (name.indexOf('yogaUniversityCredential') != -1) {
    return 'Credential';
  }
  if (name.indexOf('yogaUniversityWorkshop') != -1) {
    return 'Workshop';
  }
  if (name.indexOf('yogaUniversityLearnto') != -1) {
    return 'Learnto';
  }
  if (name.indexOf('yogaUniversityTrain') != -1) {
    return 'Train';
  }
  return 'RYT';
}

export default {
  beforeCreate() {
    document.title = '每日瑜伽_瑜伽课程_专属移动瑜伽教练';
    $("meta[name='keywords']").attr(
      'content',
      '每日瑜伽,瑜伽教学,瑜伽减肥,瑜伽视频,瑜伽的好处,瑜伽课程,孕妇瑜伽,瑜伽可以减肥吗,瘦身瑜伽,产后瑜伽,理疗瑜伽',
    );
    $("meta[name='description']").attr(
      'content',
      '瑜伽练习的好处很多，瑜伽瘦身、瑜伽理疗都适合瑜伽初学者，每日瑜伽课程包含亲子瑜伽、纤体瑜伽、丰胸瑜伽、减肥瑜伽、产后瑜伽，跟着视频练习瑜伽动作或者参加瑜伽培训都可以选择每日瑜伽。',
    );

    this.universityNav = changNavFun(this.$route.name);

    // if(window.location.hash.indexOf('#/yogaUniversity') != -1){
    //   var hm = document.createElement("script");
    //   hm.src = "https://hm.baidu.com/hm.js?9c7361f4b15d9443b8ba2d83324c9168";
    //   var s = document.getElementsByTagName("script")[0];
    //   s.parentNode.insertBefore(hm, s);
    // }

    //获取banner
    this.$axios
      .get(DY.baseUrl + 'common/banner_conf?item=university')
      .then((rsp) => {
        if (rsp.data.error_code == 0) {
          this.banner = rsp.data.result;
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    this.$axios
      .get(DY.baseUrl + 'yoga_university/session/ryt/last/web_info')
      .then((rsp) => {
        if (rsp.data.error_code == 0) {
          this.id = rsp.data.result.session_id;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },

  created() {
    reportPageViewEvent({
      page_id: 208,
      pageinfo: location.href,
    });
  },

  data() {
    return {
      scrollBottom: 0,
      universityNav: (this.universityNav = changNavFun(this.$route.name)),
      banner: {},
      name: '',
      mobile: '',
      error: '',
      isQrCode: 0,
      id: 0,
    };
  },

  watch: {
    $route: 'changeNav',
  },

  methods: {
    buyRYT() {
      if (DY.isMobile) {
        window.open(url);
        return;
      }

      this.isQrCode = !this.isQrCode;
    },
    apply() {
      if (!this.name || !this.mobile) {
        this.error = '请完善信息';
        return;
      }

      if (!/^1[34578]\d{9}$/.test(this.mobile)) {
        this.error = '手机号不正确';
        return;
      }

      this.$axios
        .post(
          DY.baseUrl + 'yoga_university/ryt_apply',
          qs.stringify({
            name: this.name,
            mobile: this.mobile,
          }),
        )
        .then((rsp) => {
          if (rsp.data.error_code != 0) {
            this.error = rsp.data.error_desc;
            return;
          }

          this.error = '提交成功，工作人员将尽快与您联系';
          this.name = '';
          this.mobile = '';
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    changeNav() {
      this.universityNav = changNavFun(this.$route.name);
    },
  },

  mounted() {
    // $('#qrCodeRYT').html('');
    //
    // var qrcode = new QRCode("qrCodeRYT", {
    //   width: 120,
    //   height: 120,
    //   colorDark : "#000000",
    //   colorLight : "#ffffff",
    //   correctLevel : QRCode.CorrectLevel.H
    // });
    // qrcode.makeCode(url);
  },
};
</script>



// WEBPACK FOOTER //
// src/view/yogaUniversity.vue